export enum TopChartEnum {
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}
